import type { StreamingLifecycleCommandProperties } from '@atlassian/rovo-content-bridge-api-commands/commands/streaming-lifecycle-commands';

import { CommandHandler } from './command-handler';
import type { PassThroughCommandProps } from './command-handler';

export class StreamCompletedCommandHandler extends CommandHandler<
	StreamingLifecycleCommandProperties,
	void
> {
	constructor(
		props: PassThroughCommandProps,
		private onCompleted: (command: StreamingLifecycleCommandProperties) => void,
	) {
		super(props);
	}

	execute(command: StreamingLifecycleCommandProperties): void {
		try {
			this.onCompleted(command);
		} catch {
			// Match stream error handling: lifecycle cleanup must not throw into Chat.
		}
	}
}
